import React from 'react';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-brand">
          <div className="doctor-section">
            <img src="/dr.jpg" alt="Dr. Moisés Mejía" className="doctor-photo" />
            <p className="mentor-phrase">Mentoría con Dr. Moisés Mejía</p>
          </div>
        </div>
        <ul className="nav-menu">
          <li><a href="#inicio">Inicio</a></li>
          <li><a href="#acerca">Acerca</a></li>
          <li><a href="#recursos">Recursos</a></li>
          <li><a href="#contacto">Contacto</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;